module.exports = __webpack_public_path__ + "assets/edit-wait.5d466bcd.svg";